import { render, staticRenderFns } from "./Leave.html?vue&type=template&id=3deb81e4&scoped=true&"
import script from "./Leave.ts?vue&type=script&lang=ts&"
export * from "./Leave.ts?vue&type=script&lang=ts&"
import style0 from "./Leave.css?vue&type=style&index=0&id=3deb81e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb81e4",
  null
  
)

export default component.exports